<template>
  <div id="layout">
    <Header @open_vip="showUpgrade" @newOpen_vip="showPayRetainPop"></Header>
    <div class="main">
      <Aside></Aside>
      <div class="con">
        <router-view></router-view>
      </div>
    </div>
    <!-- 登录弹窗 -->
    <Login v-if="show_login_compoments"></Login>
    <!-- 展示个人资料 -->
    <UserInfo v-if="show_userinfo_compoments"></UserInfo>
    <!-- 修改绑定手机号 -->
    <BindPhone v-if="show_bindphone_compoments"></BindPhone>
    <!-- 激活码兑换 -->
    <CodeExchange v-if="show_code_exchange_compoments"></CodeExchange>
    <!-- 每日签到 -->
    <AttenDance v-if="show_attendance_compoments"></AttenDance>
    <!--    &lt;!&ndash; 开通弹窗 &ndash;&gt;-->
    <!--    <Open></Open>-->
    <!--    &lt;!&ndash; 常见问题 &ndash;&gt;-->
    <!--    <Question v-if="show_question_compoments"></Question>-->
    <!-- Vip 提示框 -->
    <toastVip v-if="show_toast_vip"
              @vipOpenHandle="vipOpenHandle"></toastVip>
    <!-- 分享海报 -->
    <!--    <InviteCode v-if="shou_invite_code"></InviteCode>-->

    <!-- 推广弹框 -->
    <welcomeAd ref="welcomePanelAd"></welcomeAd>
    <updatalog ref="updatalog"></updatalog>

    <!-- 限时会员 -->
    <hdProvisionalUpgrade ref="HdUpgraderef" @callBack="haveBack" @addDesk="addDesk"></hdProvisionalUpgrade>
    <!-- 永久会员 -->
    <HdProvisionalMember ref="HdProvisionalMember"></HdProvisionalMember>
    <!-- 客户端提示弹框 -->
    <ClientPopup ref="ClientPopup" v-if="show_kehu_tip"></ClientPopup>
    <!-- 右侧悬浮 -->
    <RightFunPop></RightFunPop>
    <!-- 新支付弹框 -->
    <newPay v-if="isPayPopShow" @up_rig_sta = 'checkYouhuiTip' @succ_pay="paySuccessFn" @addDesk="addDesk"></newPay>

    <!-- 恭喜你成为xxx会员弹框 -->
    <congratulations_on_becoming v-if="vip_congratulations_show" @addDesk="addDesk"></congratulations_on_becoming>
    <!-- 挽留永久优惠券弹窗 -->
    <eveVipMoneyPop @showPayRetainPop="showPayRetainPop" ref="eveVipMoneyPopref"></eveVipMoneyPop>
    <!-- 加桌弹窗 -->
     <NewPwaPanel ref="newpwapanel"></NewPwaPanel>
    <!-- 模拟挽留 -->
     <!-- <div class="moniBtn" @click="addDesk">加桌测试</div> -->
<!--       <div class="moniBtn" @click="moniBtnClick">升级永久测试</div>-->

    <!-- 全新升级 技术维护弹窗 -->
    <optTechnical v-if="Technical_Show"></optTechnical>
<!--    <optTechnical></optTechnical>-->
  </div>
</template>
<script type="text/ecmascript-6">
import Header from '@/components/Header'
import Aside from '@/components/Aside'
import Login from '@/components/Login'
import UserInfo from '@/components/UserInfo'
import BindPhone from '@/components/BindPhone'
import CodeExchange from '@/components/CodeExchange'
import AttenDance from '@/components/AttenDance'
import Open from '@/components/Open'
import Question from '@/components/Question'
import toastVip from '@/components/ToastVip'
import InviteCode from '@/components/InviteCode'
import welcomeAd from "COMPONENTS/Welcome_ad.vue"
import updatalog from '@/components/Updatalog.vue'
import RightFunPop from '@/components/RightFunPop.vue'
import newPay from '@/components/newPay.vue'

import hdProvisionalUpgrade from "COMPONENTS/HdProvisionalUpgrade.vue";
import HdProvisionalMember from "COMPONENTS/HdProvisionalMember.vue";
import ClientPopup from "@/components/ClientPopup.vue";

import eveVipMoneyPop from '@/components/eveVipMoneyPop.vue'
import congratulations_on_becoming from '@/components/congratulations_on_becoming.vue'
import NewPwaPanel from '@/components/NewPwaPanel.vue'
import optTechnical from '../components/optTechnical.vue'
import utils from '../../utils'
import md5 from 'js-md5'
export default {
  components: {
    newPay,
    updatalog,
    Header,
    Aside,
    Login,
    UserInfo,
    BindPhone,
    CodeExchange,
    AttenDance,
    Open,
    Question,
    toastVip,
    InviteCode,
    welcomeAd,
    hdProvisionalUpgrade,
    HdProvisionalMember,
    ClientPopup,
    RightFunPop,
    eveVipMoneyPop,
    congratulations_on_becoming,
    NewPwaPanel,
    optTechnical,
  },
  data() {
    return {}
  },

  mounted() {
    
  },
  created() {
    utils.getIsTime()
    let ttl = 120 * 60 * 1000; // 2个小时
    let keyword = ""; // 广告关键词
    // 非推广页面
    if (this.$route.query.invite_id) {
      localStorage.setItem("invite_id", this.$route.query.invite_id);
    }
    // 媒体ID
    if (this.$route.query.adaid) {
      this.setCache("ad_account_id", this.$route.query.adaid, ttl)
    }
    if (this.$route.query.adsid) {
      this.setCache("site_id", this.$route.query.adsid, ttl);
    }
    // 必应广告参数
    this.setCache("msclkid", this.$route.query.msclkid || '', ttl);
    // 百度广告参数
    this.setCache("bd_vid", this.$route.query.bd_vid || this.$route.query.msclkid || '', ttl);
    // 360搜索推广参数
    this.setCache("qhclickid", this.$route.query.qhclickid || '', ttl);
    // 360展示广告参数
    this.setCache("sourceid", this.$route.query.sourceid || '', ttl);

    let token = this.$route.query.token || '';
    if (token) {
      localStorage.setItem("token", token);
    }
    //判断url中是否带有token
    let resu = location.href.indexOf('token')
    let url = window.location.origin + this.$route.path

    if (resu > 0 || location.href.indexOf('tgad') > 0 || location.href.indexOf('adaid') > 0) {
      // this.$router.push('/video')
      // console.log(this.$router)
      let path = this.$route.query.path || ''
      if (path == '') {
        if (this.$route.path == '/') {
            this.$router.replace('/create')
          } else {
            window.location.href = url
          }
      } else {
      this.$router.replace({path: path, query: {}})

      }
      
      // location.reload()
      // alert(123)
      // return
      // alert(this.$router)
    }
    // 推广页面 开始
    if (this.$router.currentRoute.name == "index_ad"||this.$router.currentRoute.name == "zz360tg" || this.$router.currentRoute.name == "tg") {
      let ad_account_id = AD_AID
      if(this.$router.currentRoute.name == "zz360tg"){
        ad_account_id = AD_AID; // 媒体ID
      }else if (this.$router.currentRoute.name == "index_ad"){
        ad_account_id = AD_360_AID; // 媒体ID
      }
      this.$http.get('https://apimid.m.nengshuohuihua.com/wap/tgpage/landingpage/?md5_key='+md5(url))
      .then(res => {
        if (res.data.page_url != '') {
          JUMP_DIALOG = res.data.login_jump ? 0 : 1
          MAIN_URLROOT = res.data.page_url
        }
      }).catch(err => {
        console.log(err)
      })

      this.setCache("ad_account_id", ad_account_id, ttl);
      
      // 搜索关键词
      this.setCache("keyword", this.$route.query.q || '', ttl);
      // 必应广告参数
      this.setCache("msclkid", this.$route.query.msclkid || '', ttl);
      // 百度广告参数
      this.setCache("bd_vid", this.$route.query.bd_vid || this.$route.query.msclkid || '', ttl);
      // 360搜索推广参数
      this.setCache("qhclickid", this.$route.query.qhclickid || '', ttl);
      // 360展示广告参数
      this.setCache("sourceid", this.$route.query.sourceid || '', ttl);

      if (this.$route.query.bd_vid || this.$route.query.msclkid || this.$route.query.qhclickid) {
        // 是否广告搜索过来
        this.is_ad = 1
      }
      if (this.getCache("tgad")) {
        this.is_ad = 1
      }

      var referrer = document.createElement('a');
      referrer.href = document.referrer;
      if (referrer.href) {
        let ref_params = this.getUrlParams(referrer.href)
        keyword = ref_params.q || ''
        if (keyword) {
          keyword = decodeURI(keyword)
        }
        localStorage.setItem("keyword", keyword);
      }

      if (referrer.href.indexOf("so.com") > 1 && this.is_ad == 1) {
        // 360 广告
        this.setCache("tgad", "111", ttl);
      } else if (referrer.href.indexOf("baidu.com") > 1 && this.is_ad == 1) {
        // 百度 广告
        this.setCache("tgad", "122", ttl);
      } else if (referrer.href.indexOf("cn.bing.com") > 1 && this.is_ad == 1) {
        // 必应 广告
        this.setCache("tgad", "123", ttl);
      }
      // 提交搜索词
      let user_id = localStorage.getItem("user_id") || 0;
      this.$http.post('/wap/jsstat/adacount/record/', {
        user_id: user_id, keyword: keyword, ad_account_id: ad_account_id, referrer: referrer.href,
        bd_vid: this.$route.query.bd_vid,
        qhclickid: this.$route.query.qhclickid,
        msclkid: this.$route.query.msclkid
      })
      this.$http.post('https://apimid.m.nengshuohuihua.com/wap/tgpage/landingpv/', {
            
      ad_account_id: ad_account_id,
      referrer: referrer.href,
      keyword: keyword,
      bd_vid: this.$route.query.bd_vid,
      qhclickid: this.$route.query.qhclickid,
      msclkid: this.$route.query.msclkid,
      md5_key: md5(url),
      cur_page_url: url
    })
    }
    // 推广页面 结束

    this.showServer()

    this.fetchProfile()
    // 加载必应基础代码
    let msclkid = this.getCache("msclkid") || ""
      let adaid = this.getCache("ad_account_id") || "" // 访问落地页时确定 ad_account_id 值
      if (msclkid !== "") {
        let _ti = "343210724"
        let arr = BY_UET_CODE.split('|')
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].split('_')[0] == adaid) {
            _ti = arr[i].split('_')[1]
          }
        }
        var uetCode = '(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"' + _ti + '", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");';
        var newScript = document.createElement('script');
        newScript.type = 'text/javascript';
        newScript.innerHTML = uetCode;
        document.body.appendChild(newScript);
      }
  },
  computed: {
    show_login_compoments() {
      return this.$store.state.show_login_compoments
    },
    show_userinfo_compoments() {
      return this.$store.state.show_userinfo_compoments
    },
    show_code_exchange_compoments() {
      return this.$store.state.show_code_exchange_compoments
    },
    show_bindphone_compoments() {
      return this.$store.state.show_bindphone_compoments
    },
    show_attendance_compoments() {
      return this.$store.state.show_attendance_compoments
    },
    show_question_compoments() {
      return this.$store.state.show_question_compoments
    },
    show_toast_vip() {
      return this.$store.state.show_toast_vip
    },
    shou_invite_code() {
      return this.$store.state.shou_invite_code
    },
    show_kehu_tip(){
      return this.$store.state.show_kehu_tip
    },
    isPayPopShow() {
      return this.$store.state.isPayPopShow;
    },
    userInfo(){
      return this.$store.state.userInfo;
    },
    vip_congratulations_show() {
      return this.$store.state.vip_congratulations_show
    },
    Technical_Show() {
      return this.$store.state.Technical_Show
    },
  },
  methods: {
    moniBtnClick(){
      if([1,2,3,6].includes(this.userInfo.vip_type)){
        this.$store.commit('setFisYouh', true)
      }
    },
    // 新提示加桌
    addDesk() {
      console.log(' layout addDesk新提示加桌')
      if (utils.getIsZeroTime('addDeskTime') && !localStorage.getItem('eveClose')) {//是否过0点
        // alert(window.deferredPrompt)
        if (window.deferredPrompt) {
          setTimeout(() => {
            this.$refs.newpwapanel.show();
            localStorage.setItem('addDeskTime', JSON.stringify({ time: new Date().getTime() }))
          }, 3000);
        }
      }
    },
    // 显示支付挽留弹框
    showPayRetainPop(){
      let up_id = `${this.userInfo.vip_type}-1`
      this.$http.get('/front/aivideo/pay/today_order/',{params:{
        upgrade_id:up_id //领完50 1_1 领完100 2_1
      }}).then(res => {
        this.$refs.HdUpgraderef.show()
        this.$refs.HdUpgraderef.setDetail(res.data)
      })
    },
    paySuccessFn(data) {
      // 支付成功
      //this.userInfo.vip_type
      if ([1, 2, 3,6].includes(this.userInfo.vip_type)) {
        // chongzhi()
        this.$refs.HdUpgraderef.setHdupShow(true)
        this.$refs.HdUpgraderef.setYouhui({ type: this.userInfo.vip_type, gr_lv: data.curVipId })

      } else {
        localStorage.removeItem('isTodyYouh')
        this.$refs.HdUpgraderef.setyouHuiTpye(5)
        this.$refs.HdUpgraderef.setHdupShow(true)
      }
      // emit('up_rig_sta')
      // this.$emit('up_rig_sta')
      this.checkYouhuiTip()

    },
    checkYouhuiTip() {
      if (this.userInfo.vip_type && this.userInfo.vip_type != 5) {
        this.$http.get('/front/aivideo/pay/today_order/').then(res => {
          if (res.status == 200) {
            this.$store.commit('showVipTime', true)
            // this.$ref.disTipRef.closeBtn()
            this.$store.commit('setUpyouDetail', res.data)

          }
          if (res.status == -1) {
            this.$store.commit('showVipTime', false)
          }
          if(res.status==401){
            throw new Error(`HTTP status ${res.status}`)
            // throw res
          }
        }).catch(err => {
          if (localStorage.getItem('paynum')) {
            let kehuInfo = localStorage.getItem('isTodyYouh')
            if (kehuInfo) {
              kehuInfo = JSON.parse(kehuInfo)
              let start_time = kehuInfo.time
              const STORAGE_KEY = 'isTodyYouh';
              const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
              const TWELVE_HOURS2 = 168 * 60 * 60 * 1000; // 7天的毫秒数

              const currentTime = Date.now();

              // 计算时间差
              const timeDiff = currentTime - parseInt(start_time, 10);
              let clientDownDate = localStorage.getItem('isTodyYouh') || 0
              // 超过12小时执行操作
              if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
                this.$store.commit('showVipTime', false)
                localStorage.removeItem('isTodyYouh')
              } else {
                this.$store.commit('showVipTime', true)
                // this.$refs.disTipRef.closeBtn()

              }
            } else {
              this.$store.commit('showVipTime', false)

            }
          } else {
            // payKeStore.showVipTime(false)
            this.$store.commit('showVipTime', false)
          }
        })
      } else {
        let kehuInfo = localStorage.getItem('isTodyYouh')
        if (kehuInfo) {
          kehuInfo = JSON.parse(kehuInfo)
          let start_time = kehuInfo.time
          const STORAGE_KEY = 'isTodyYouh';
          const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
          const TWELVE_HOURS2 = 168 * 60 * 60 * 1000; // 7天的毫秒数

          const currentTime = Date.now();

          // 计算时间差
          const timeDiff = currentTime - parseInt(start_time, 10);
          let clientDownDate = localStorage.getItem('isTodyYouh') || 0
          // 超过12小时执行操作
          if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
            // payKeStore.showVipTime(false)
            this.$store.commit('showVipTime', false)
            localStorage.removeItem('isTodyYouh')
          } else {
            // payKeStore.showVipTime(true)     
            this.$store.commit('showVipTime', true)
            // disTipRef.value.closeBtn()

          }
        } else {
          // payKeStore.showVipTime(false)
          this.$store.commit('showVipTime', false)

        }
      }
    },
    getUrlParams(url) {
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split('?')[1]
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      if (urlStr) {
        let paramsArr = urlStr.split('&')
        for (let i = 0, len = paramsArr.length; i < len; i++) {
          // 再通过 = 将每一个参数分割为 key:value 的形式
          let arr = paramsArr[i].split('=')
          obj[arr[0]] = arr[1];
        }
      }
      return obj
    },
    showServer() {
      //添加客服好友的弹窗
      if (this.$router.currentRoute.name == "index_ad"||this.$router.currentRoute.name == "zz360tg" ||  this.$router.currentRoute.name == "tg") {
        console.log('执行')
        let timer = setInterval(() => {
          if (this.$refs.welcomePanelAd) {
            this.$refs.welcomePanelAd.show()
            clearInterval(timer);
          }
        }, 100)

      } else {
        // this.$refs.welcomePanel.show();
      }
    },
    fetchProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
          if (res.data.show_notice == 1) {
            this.$refs.updatalog.show(1)
          }
          if(localStorage.getItem('ling1')||localStorage.getItem('ling2')){
            let localTime = localStorage.getItem('heade_r_show')
            // let localTime = Date.now() - 1
            if(localTime){
              // 10分钟过期
              if (Date.now() - localTime >= 10*60*1000) {
                // this.$store.commit('setVipYouhuiHeaderShow',)
                this.$store.commit('setHeader_r_show',1)
              }else{
                this.$store.commit('setVipYouhuiHeaderShow',true)
                this.$store.commit('setHeader_r_show',2)
              }
            }else{
              if(localStorage.getItem('paynum')){
                this.$store.commit('setVipYouhuiHeaderShow',true)
                this.$store.commit('setHeader_r_show',1)
              }
            }
          }else{
            if(localStorage.getItem('paynum')){
              this.$store.commit('setVipYouhuiHeaderShow',true)
              this.$store.commit('setHeader_r_show',1)
            }
          }
           if (document.location.href.indexOf(MAIN_URLROOT.split('.com')[0]) == -1){
            let url = MAIN_URLROOT
            let path = this.$router.currentRoute.path
             if (this.$router.currentRoute.name == "index_ad"||this.$router.currentRoute.name == "zz360tg" ||  this.$router.currentRoute.name == "tg") {
              path = '/video'
             }
            url += '?path='+ path
            url += "&token=" + localStorage.getItem("token");
            location.href = url
          }
          // this.checkYouhuiTip()
        }
      }).finally(() => {

      })
    },
    vipOpenHandle() {
      // this.$router.push("/member");
      this.$store.commit('setisPayPopShow', true)
      // 开通会员
      // this.$store.commit('setShowOpen', true)
    },
    showUpgrade(){
      // console.log('open_vip')
      // this.$refs.hdProvisionalUpgrade.show()
      if(this.userInfo.vip_type){
        this.$http.get('/front/aivideo/pay/today_order/').then(res=>{
        if(res.status == 200){
          this.$refs.HdUpgraderef.setHdupShow(true)
          this.$refs.HdUpgraderef.show()
          this.$refs.HdUpgraderef.setyouHuiTpye(4)
          this.$store.commit('setUpyouDetail', res.data)
        }else{
          this.$store.commit('setisPayPopShow', true)
        }
        }).catch(err=>{
          this.$store.commit('setisPayPopShow', true)
        })
      }else{
          this.$store.commit('setisPayPopShow', true)
      }
    },
    // openCongrats(){
    //   console.log('open_vip')
    //   this.$refs.HdProvisionalMember.show()
    // },
    haveBack(){
      console.log('haveBack')
      this.$refs.HdProvisionalMember.show()
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .main {
    height: calc(100vh - 40px);

    display: flex;
    justify-content: space-between;

    .con {
      flex: 1 1 0%;
      overflow: hidden;
    }
  }
}
.moniBtn{
  width: 300px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 30px;
  left: 30px;
  background: #ccc;
}
</style>